import EurailCards from './eurail-cards-component';
import EurailCardsService from './eurail-cards-service';

import './eurail-cards.scss';

const MODULE_NAME = 'app.common.widgets.eurail-cards';
const module = angular.module(MODULE_NAME, [])
    .directive(EurailCards.DIRECTIVE_NAME, EurailCards)
    .service('eurailCardsService', EurailCardsService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/eurail-cards/eurail-cards-module.js